<div id="matDialogContent">
  <div class="innerContent" [innerHtml]="data.data.data | bbCode">
  </div>
</div>
